<template>
  <div style="background: #F0F2F5 !important;
        padding: 16px !important;;" class="todoindex">
        <!-- <span class="todotitle">已办事项</span> -->
    <div class="todomenu" :style="conheight">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="已办流程" name="done">
                <done v-if="isChildUpdate1"></done>
            </el-tab-pane>
            <el-tab-pane label="我转办的" name="myDelegate">
                <myDelegate v-if="isChildUpdate2"></myDelegate>
            </el-tab-pane>
             <el-tab-pane label="我传阅的" name="myRead">
                <myRead  v-if="isChildUpdate3"></myRead>
            </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>


<script>
import done from "@/components/flow/done.vue";//已办
import myDelegate from "@/components/flow/myDelegate.vue";//我转办的
import myRead from "@/components/flow/myRead.vue";//我传阅的
  export default {
    name: "haiyaDone",
     components: {
        done,
        myDelegate,
        myRead
    },
    data() {
      return {
        activeName: 'done',
         isChildUpdate1:true,
         isChildUpdate2:false,
         isChildUpdate3:false,
         conheight: { height: window.innerHeight  + "px"},    
      };
    },
    methods: {
        handleClick(tab, event) {
            if(tab.name == "done") {
                this.isChildUpdate1 = true;
                this.isChildUpdate2 = false;
                this.isChildUpdate3 = false;
            } else if(tab.name == "myDelegate") {
                this.isChildUpdate1 = false;
                this.isChildUpdate2 = true;
                this.isChildUpdate3 = false;
            } else if(tab.name == "myRead"){
                this.isChildUpdate1 = false;
                this.isChildUpdate2 = false;
                this.isChildUpdate3 = true;
            }
        },
        },
    mounted(){
      window.jQuery(".el-container").find(".el-main").css({"height":window.innerHeight+"px","overflow":"hidden"});
    }
  };
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .el-tabs__header{
  margin: 0px !important;
  padding-top: 8px;
}

/deep/ .el-main .base-main{//隐藏外层滚动条
    overflow:hidden !important;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
  }
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;
}
    /deep/ .todotitle{
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #292B44;
    }



</style>
